import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import javascript from "../assets/javascript.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";

import profile_2 from "../assets/profile-2.png";
import circle from "../assets/circle.svg";

export default {
  profile_2,
  email,
  mobile,

  javascript,

  node,
  python,
  react,
  redux,
  sass,

  circle,
};
